import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect } from "vue"
import _imports_0 from '@/assets/images/admin-img/image-icon.svg'
import _imports_1 from '@/assets/images/admin-img/light_delete-outline.svg'


const _hoisted_1 = { id: "mainContainer" }
const _hoisted_2 = { class: "admin-mid-container" }
const _hoisted_3 = {
  class: "admin-custom-row admin-page-row",
  id: "leftMenuSlideBox"
}
const _hoisted_4 = { class: "admin-right-sidebar" }
const _hoisted_5 = { class: "admin-right-sidebar-in" }
const _hoisted_6 = { class: "admin-right-sidebar-in-top" }
const _hoisted_7 = { class: "admin-custom-row" }
const _hoisted_8 = { class: "admin-right-sidebar-in-top-left" }
const _hoisted_9 = { class: "admin-page-type-links" }
const _hoisted_10 = { class: "admin-right-sidebar-in-top-right" }
const _hoisted_11 = { class: "admin-right-sidebar-in-top-right-top" }
const _hoisted_12 = { class: "admin-search-box" }
const _hoisted_13 = { class: "admin-add-btn" }
const _hoisted_14 = {
  key: 0,
  class: "admin-right-sidebar-in-top-right-btm"
}
const _hoisted_15 = { class: "tags" }
const _hoisted_16 = { class: "delete-all-btn-link" }
const _hoisted_17 = {
  key: 0,
  class: "white-bg-border add-new-section"
}
const _hoisted_18 = { class: "add-banner-image-section" }
const _hoisted_19 = { class: "add-banner-image-box" }
const _hoisted_20 = { class: "admin-input-field" }
const _hoisted_21 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_22 = { class: "admin-input-field" }
const _hoisted_23 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_24 = { class: "admin-input-field" }
const _hoisted_25 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_26 = { class: "admin-input-field" }
const _hoisted_27 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_28 = { class: "admin-input-field" }
const _hoisted_29 = { class: "image-upload-input upload-banner-image" }
const _hoisted_30 = { class: "file-input-box" }
const _hoisted_31 = {
  key: 0,
  class: "image-upload-input-item-in"
}
const _hoisted_32 = {
  key: 1,
  class: "image-upload-input-item-uploaded"
}
const _hoisted_33 = ["src"]
const _hoisted_34 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_35 = { class: "admin-input-field-submit" }
const _hoisted_36 = ["disabled"]
const _hoisted_37 = {
  class: "admin-item-list-section-in",
  ref: "scrollWrapper",
  "data-simplebar": ""
}
const _hoisted_38 = { class: "admin-item-list-section-scroll" }
const _hoisted_39 = { class: "admin-item-list-top" }
const _hoisted_40 = { class: "admin-item-list-row" }
const _hoisted_41 = { class: "admin-item-checkbox" }
const _hoisted_42 = { class: "admin-checkbox-input" }
const _hoisted_43 = ["checked"]
const _hoisted_44 = { class: "admin-item-image" }
const _hoisted_45 = { class: "admin-item-actions" }
const _hoisted_46 = { class: "admin-item-list-btm" }
const _hoisted_47 = { ref: "sortableList" }
const _hoisted_48 = { class: "admin-item-box-top" }
const _hoisted_49 = { class: "admin-item-list-row" }
const _hoisted_50 = { class: "admin-item-checkbox" }
const _hoisted_51 = { class: "admin-checkbox-input" }
const _hoisted_52 = ["id", "onChange", "checked"]
const _hoisted_53 = ["for"]
const _hoisted_54 = { class: "admin-item-image" }
const _hoisted_55 = { class: "sm-img" }
const _hoisted_56 = ["src"]
const _hoisted_57 = { class: "admin-item-team-name" }
const _hoisted_58 = { class: "limited-text text-limit" }
const _hoisted_59 = { class: "admin-item-team-email" }
const _hoisted_60 = { class: "admin-item-team-designation text-limit" }
const _hoisted_61 = { class: "admin-item-team-description text-limit" }
const _hoisted_62 = { class: "admin-item-actions" }
const _hoisted_63 = { class: "admin-action-link" }
const _hoisted_64 = ["onClick"]
const _hoisted_65 = ["onClick"]
const _hoisted_66 = ["onClick"]
const _hoisted_67 = ["onClick"]
const _hoisted_68 = {
  key: 0,
  class: "admin-item-box-btm"
}
const _hoisted_69 = { class: "add-banner-image-section" }
const _hoisted_70 = { class: "add-banner-image-box" }
const _hoisted_71 = { class: "admin-input-field" }
const _hoisted_72 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_73 = { class: "admin-input-field" }
const _hoisted_74 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_75 = { class: "admin-input-field" }
const _hoisted_76 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_77 = { class: "admin-input-field" }
const _hoisted_78 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_79 = { class: "admin-input-field" }
const _hoisted_80 = { class: "image-upload-input upload-banner-image" }
const _hoisted_81 = { class: "image-upload-input-item uploaded-done" }
const _hoisted_82 = { class: "file-input-box" }
const _hoisted_83 = { class: "image-upload-input-item-uploaded" }
const _hoisted_84 = ["src"]
const _hoisted_85 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_86 = { class: "admin-input-field-submit" }
const _hoisted_87 = ["onClick"]
const _hoisted_88 = { class: "admin-pagination-section" }
const _hoisted_89 = { class: "custom-row" }
const _hoisted_90 = { class: "item-show-selectbox" }
const _hoisted_91 = {
  key: 0,
  class: "admin-pagination",
  id: "paginationBox"
}
const _hoisted_92 = ["onClick"]
const _hoisted_93 = { key: 2 }
const _hoisted_94 = { class: "admin-site-footer" }
const _hoisted_95 = { class: "container" }
const _hoisted_96 = {
  class: "modal fade confirmation-popup",
  id: "deletePop",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "deleteModalLabel",
  "aria-hidden": "true",
  "data-bs-backdrop": "static"
}
const _hoisted_97 = {
  class: "modal-dialog",
  role: "document"
}
const _hoisted_98 = { class: "modal-content" }
const _hoisted_99 = { class: "confirmation-popup-mid" }
const _hoisted_100 = { class: "confirmation-popup-btm" }
const _hoisted_101 = {
  id: "popNoBtn",
  class: "admin-btn-outline-secondary",
  "data-bs-dismiss": "modal"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_adminHeader = _resolveComponent("adminHeader")!
  const _component_adminNavigation = _resolveComponent("adminNavigation")!
  const _component_ckeditor = _resolveComponent("ckeditor")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_adminHeader),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_adminNavigation),
        _createElementVNode("section", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("h1", null, _toDisplayString(_ctx.constants.MANAGE_TEAM_TEXT), 1),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("ul", null, [
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          id: "allLink",
                          href: "#",
                          class: _normalizeClass({ active: _ctx.activeTab === 'all' }),
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.switchView('all')))
                        }, [
                          _createTextVNode(_toDisplayString(_ctx.constants.ALL_LINK) + " ", 1),
                          _createElementVNode("span", null, _toDisplayString(_ctx.counts.all), 1)
                        ], 2)
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          id: "publishedhLink",
                          href: "#",
                          class: _normalizeClass({ active: _ctx.activeTab === 'published' }),
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.switchView('published')))
                        }, [
                          _createTextVNode(_toDisplayString(_ctx.constants.PUBLISHED_LINK) + " ", 1),
                          _createElementVNode("span", null, _toDisplayString(_ctx.counts.published), 1)
                        ], 2)
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          id: "unPublishedhLink",
                          href: "#",
                          class: _normalizeClass({ active: _ctx.activeTab === 'unpublished' }),
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.switchView('unpublished')))
                        }, [
                          _createTextVNode(_toDisplayString(_ctx.constants.UNPUBLISHED_LINK) + " ", 1),
                          _createElementVNode("span", null, _toDisplayString(_ctx.counts.unpublished), 1)
                        ], 2)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _withDirectives(_createElementVNode("input", {
                        id: "seachTeamInput",
                        type: "text",
                        placeholder: "Search",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchedText) = $event)),
                        onKeyup: _cache[4] || (_cache[4] = _withKeys(($event: any) => (_ctx.fetchTeams(_ctx.activeTab), _ctx.fetchCounts(_ctx.searchedText)), ["enter"]))
                      }, null, 544), [
                        [_vModelText, _ctx.searchedText]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("button", {
                        id: "addBlogBtn",
                        class: _normalizeClass(["add-btn-admin", { 'active': _ctx.showAddForm }]),
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showAddForm = true, _ctx.selectedTeams = [], _ctx.selectAll = false, _ctx.cancelEdit()))
                      }, [
                        _cache[33] || (_cache[33] = _createElementVNode("i", { class: "add-icon" }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.constants.ADD_MEMBER_BUTTON), 1)
                      ], 2)
                    ])
                  ]),
                  (_ctx.selectedTeams.length > 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("ul", null, [
                            _createElementVNode("li", null, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.selectedTeams.length) + " entries selected", 1),
                              _createElementVNode("button", {
                                id: "tagCloseBtn",
                                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.selectedTeams = [], _ctx.selectAll = false))
                              })
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("button", {
                            class: "btn_link",
                            id: "deleteAllBtn",
                            "data-bs-toggle": "modal",
                            "data-bs-target": "#deletePop",
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.setDeleteMode('all')))
                          }, _toDisplayString(_ctx.constants.DELETE_ALL_BUTTON), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            (_ctx.showAddForm)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("h2", null, _toDisplayString(_ctx.constants.ADD_NEW_TEAM_MEMBER_TEXT), 1),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("form", {
                        id: "addTeamForm",
                        onSubmit: _cache[15] || (_cache[15] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
                      }, [
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("label", null, _toDisplayString(_ctx.constants.NAME_LABEL), 1),
                          _withDirectives(_createElementVNode("input", {
                            id: "memberNameInput",
                            type: "text",
                            placeholder: "Enter the Name",
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.newTeam.name) = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.newTeam.name]
                          ]),
                          (!_ctx.newTeam.name)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_ctx.errMsg), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("label", null, _toDisplayString(_ctx.constants.EMAIL_LABEL), 1),
                          _withDirectives(_createElementVNode("input", {
                            id: "memberEmailInput",
                            type: "text",
                            placeholder: "Enter the Email",
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.newTeam.email) = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.newTeam.email]
                          ]),
                          (!_ctx.newTeam.email)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(_ctx.errMsg), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("label", null, _toDisplayString(_ctx.constants.DESIGNATION_LABEL), 1),
                          _withDirectives(_createElementVNode("input", {
                            id: "memberDesignationInput",
                            type: "text",
                            placeholder: "Enter the Designation",
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.newTeam.designation) = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.newTeam.designation]
                          ]),
                          (!_ctx.newTeam.designation)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(_ctx.errMsg), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("label", null, _toDisplayString(_ctx.constants.DESCRIPTION_LABEL), 1),
                          _createVNode(_component_ckeditor, {
                            placeholder: "Description",
                            class: "text-editer",
                            id: "descInput",
                            editor: _ctx.editor,
                            modelValue: _ctx.newTeam.description,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.newTeam.description) = $event)),
                            config: _ctx.editorConfig
                          }, null, 8, ["editor", "modelValue", "config"]),
                          (!_ctx.newTeam.description)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(_ctx.errMsg), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_28, [
                          _createElementVNode("label", null, _toDisplayString(_ctx.constants.IMAGE_LABEL), 1),
                          _createElementVNode("div", _hoisted_29, [
                            _createElementVNode("div", {
                              class: _normalizeClass(['image-upload-input-item', { 'uploaded-done': _ctx.imageUploaded }])
                            }, [
                              _createElementVNode("div", _hoisted_30, [
                                _createElementVNode("button", {
                                  class: "image-upload-input-item-delete-btn",
                                  id: "uploaded-img-delete-btn",
                                  type: "button",
                                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.clearUploadedImage(false)))
                                }),
                                _createElementVNode("input", {
                                  type: "file",
                                  id: "addMemberFileInput",
                                  onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.handleFileUpload($event, false))),
                                  accept: "image/jpeg,image/jpg,image/png"
                                }, null, 32)
                              ]),
                              (!_ctx.imageUploaded)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                    _cache[34] || (_cache[34] = _createElementVNode("div", { class: "image-upload-input-item-icon" }, [
                                      _createElementVNode("img", {
                                        src: _imports_0,
                                        alt: ""
                                      })
                                    ], -1)),
                                    _createElementVNode("span", null, _toDisplayString(_ctx.constants.ADD_IMAGE_LABEL), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.imageUploaded)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                    _createElementVNode("img", {
                                      src: _ctx.imageUrl,
                                      alt: "",
                                      class: "mCS_img_loaded"
                                    }, null, 8, _hoisted_33)
                                  ]))
                                : _createCommentVNode("", true)
                            ], 2)
                          ]),
                          (!_ctx.selectedFile)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_34, _toDisplayString(_ctx.errMsg), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_35, [
                          _createElementVNode("button", {
                            class: "admin-btn-outline-primary add-new-cancel",
                            type: "submit",
                            id: "submitBtn",
                            disabled: _ctx.isSubmitting
                          }, _toDisplayString(_ctx.constants.SUBMIT_BUTTON), 9, _hoisted_36),
                          _createElementVNode("button", {
                            class: "admin-btn-outline-secondary add-new-cancel",
                            onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.resetForm && _ctx.resetForm(...args))),
                            type: "button",
                            id: "cancelBtn"
                          }, _toDisplayString(_ctx.constants.CANCEL_BUTTON), 1)
                        ])
                      ], 32)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.editTeamsData.length > 0)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass(['admin-item-list-section admin-team-section', { 'show-edit-item-outer': _ctx.editFormSubmitted }])
                }, [
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("div", _hoisted_38, [
                      _createElementVNode("div", _hoisted_39, [
                        _createElementVNode("div", _hoisted_40, [
                          _createElementVNode("div", _hoisted_41, [
                            _createElementVNode("div", _hoisted_42, [
                              _createElementVNode("input", {
                                name: "cssCheckbox",
                                id: "selectAll",
                                type: "checkbox",
                                class: "css-checkbox",
                                onChange: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.toggleSelectAll && _ctx.toggleSelectAll(...args))),
                                checked: _ctx.selectAll === true
                              }, null, 40, _hoisted_43),
                              _cache[35] || (_cache[35] = _createElementVNode("label", { for: "selectAll" }, null, -1))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.constants.IMAGE_LABEL), 1),
                          _createElementVNode("div", {
                            class: "admin-item-team-name",
                            onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.toggleSort('name'))),
                            style: {"cursor":"pointer"}
                          }, [
                            _createTextVNode(_toDisplayString(_ctx.constants.NAME_LABEL) + " ", 1),
                            (_ctx.sortBy === 'name' || _ctx.sortBy === '-name')
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: _normalizeClass(["sorting-btn", { 'sorted': _ctx.sortBy === '-name' }])
                                }, null, 2))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", {
                            class: "admin-item-team-email",
                            onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.toggleSort('email'))),
                            style: {"cursor":"pointer"}
                          }, [
                            _createTextVNode(_toDisplayString(_ctx.constants.EMAIL_LABEL) + " ", 1),
                            (_ctx.sortBy === 'email' || _ctx.sortBy === '-email')
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: _normalizeClass(["sorting-btn", { 'sorted': _ctx.sortBy === '-email' }])
                                }, null, 2))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", {
                            class: "admin-item-team-designation",
                            onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.toggleSort('designation'))),
                            style: {"cursor":"pointer"}
                          }, [
                            _createTextVNode(_toDisplayString(_ctx.constants.DESIGNATION_LABEL) + " ", 1),
                            (_ctx.sortBy === 'designation' || _ctx.sortBy === '-designation')
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: _normalizeClass(["sorting-btn", { 'sorted': _ctx.sortBy === '-designation' }])
                                }, null, 2))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", {
                            class: "admin-item-team-description",
                            onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.toggleSort('description'))),
                            style: {"cursor":"pointer"}
                          }, [
                            _createTextVNode(_toDisplayString(_ctx.constants.DESCRIPTION_LABEL) + " ", 1),
                            (_ctx.sortBy === 'description' || _ctx.sortBy === '-description')
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: _normalizeClass(["sorting-btn", { 'sorted': _ctx.sortBy === '-description' }])
                                }, null, 2))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.constants.ACTIONS_LABEL), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_46, [
                        _createElementVNode("div", _hoisted_47, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.editTeamsData, (team, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: team.id,
                              class: _normalizeClass(['admin-item-box', { 'show-edit-item': team.editing }])
                            }, [
                              _createElementVNode("div", _hoisted_48, [
                                _createElementVNode("div", _hoisted_49, [
                                  _createElementVNode("div", _hoisted_50, [
                                    _createElementVNode("div", _hoisted_51, [
                                      _createElementVNode("input", {
                                        name: "cssCheckbox",
                                        id: 'demo_opt_' + team.id,
                                        type: "checkbox",
                                        class: "css-checkbox",
                                        onChange: ($event: any) => (_ctx.toggleTeamSelection(team.id)),
                                        checked: _ctx.selectedTeams.includes(team.id)
                                      }, null, 40, _hoisted_52),
                                      _createElementVNode("label", {
                                        for: 'demo_opt_' + team.id
                                      }, null, 8, _hoisted_53)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_54, [
                                    _createElementVNode("div", _hoisted_55, [
                                      _createElementVNode("img", {
                                        src: _ctx.getCdnImageAddress(team.teamMemberImage, `w_40,h_41/`),
                                        alt: ""
                                      }, null, 8, _hoisted_56)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_57, [
                                    _createElementVNode("div", _hoisted_58, _toDisplayString(team.name), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_59, _toDisplayString(team.email), 1),
                                  _createElementVNode("div", _hoisted_60, _toDisplayString(team.designation), 1),
                                  _createElementVNode("div", _hoisted_61, _toDisplayString(_ctx.useStripHtml(team.description)), 1),
                                  _createElementVNode("div", _hoisted_62, [
                                    _createElementVNode("ul", _hoisted_63, [
                                      _createElementVNode("li", null, [
                                        _createElementVNode("button", {
                                          id: "teamPgEditBtn",
                                          class: "editBtn",
                                          onClick: ($event: any) => (_ctx.editTeam(index), _ctx.showAddForm = false)
                                        }, _toDisplayString(_ctx.constants.EDIT_BUTTON), 9, _hoisted_64)
                                      ]),
                                      _createElementVNode("li", null, [
                                        _createElementVNode("button", {
                                          "data-bs-toggle": "modal",
                                          id: "teamPgDeleteBtn",
                                          "data-bs-target": "#deletePop",
                                          onClick: ($event: any) => (_ctx.setDeleteMode('single', team.id), _ctx.showAddForm = false, _ctx.cancelEdit())
                                        }, _toDisplayString(_ctx.constants.DELETE_BUTTON), 9, _hoisted_65)
                                      ]),
                                      _createElementVNode("li", null, [
                                        (team.status === 1)
                                          ? (_openBlock(), _createElementBlock("button", {
                                              key: 0,
                                              id: "teamPgUnPublishBtn",
                                              class: "primary-outline-btn",
                                              onClick: ($event: any) => (_ctx.changeTeamStatus(team.id, 0))
                                            }, _toDisplayString(_ctx.constants.UNPUBLISH_BUTTON), 9, _hoisted_66))
                                          : (team.status === 0)
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 1,
                                                id: "teamPgPublishBtn",
                                                class: "primary-outline-btn",
                                                onClick: ($event: any) => (_ctx.changeTeamStatus(team.id, 1))
                                              }, _toDisplayString(_ctx.constants.PUBLISH_BUTTON), 9, _hoisted_67))
                                            : _createCommentVNode("", true)
                                      ])
                                    ])
                                  ])
                                ])
                              ]),
                              (team.editing)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                                    _createElementVNode("div", _hoisted_69, [
                                      _createElementVNode("h2", null, _toDisplayString(_ctx.constants.EDIT_TEAM_MEMBER_TEXT), 1),
                                      _createElementVNode("div", _hoisted_70, [
                                        _createElementVNode("div", _hoisted_71, [
                                          _createElementVNode("label", null, _toDisplayString(_ctx.constants.NAME_LABEL), 1),
                                          _withDirectives(_createElementVNode("input", {
                                            id: "memberNameInput",
                                            type: "text",
                                            placeholder: "Enter the Name",
                                            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.editTeamData.name) = $event))
                                          }, null, 512), [
                                            [_vModelText, _ctx.editTeamData.name]
                                          ]),
                                          (!_ctx.editTeamData.name)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_72, _toDisplayString(_ctx.errEditMsg), 1))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_73, [
                                          _createElementVNode("label", null, _toDisplayString(_ctx.constants.EMAIL_LABEL), 1),
                                          _withDirectives(_createElementVNode("input", {
                                            id: "memberEmailInput",
                                            type: "text",
                                            placeholder: "Enter the Email",
                                            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.editTeamData.email) = $event))
                                          }, null, 512), [
                                            [_vModelText, _ctx.editTeamData.email]
                                          ]),
                                          (!_ctx.editTeamData.email)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_74, _toDisplayString(_ctx.errEditMsg), 1))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_75, [
                                          _createElementVNode("label", null, _toDisplayString(_ctx.constants.DESIGNATION_LABEL), 1),
                                          _withDirectives(_createElementVNode("input", {
                                            id: "memberEmailInput",
                                            type: "text",
                                            placeholder: "Enter the Email",
                                            "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.editTeamData.designation) = $event))
                                          }, null, 512), [
                                            [_vModelText, _ctx.editTeamData.designation]
                                          ]),
                                          (!_ctx.editTeamData.designation)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_76, _toDisplayString(_ctx.errEditMsg), 1))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_77, [
                                          _createElementVNode("label", null, _toDisplayString(_ctx.constants.DESCRIPTION_LABEL), 1),
                                          _createVNode(_component_ckeditor, {
                                            placeholder: "Description",
                                            id: "descInput",
                                            class: "text-editer",
                                            editor: _ctx.editor,
                                            modelValue: _ctx.editTeamData.description,
                                            "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.editTeamData.description) = $event)),
                                            config: _ctx.editorConfig
                                          }, null, 8, ["editor", "modelValue", "config"]),
                                          (!_ctx.editTeamData.description)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_78, _toDisplayString(_ctx.errEditMsg), 1))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_79, [
                                          _createElementVNode("label", null, _toDisplayString(_ctx.constants.IMAGE_LABEL), 1),
                                          _createElementVNode("div", _hoisted_80, [
                                            _createElementVNode("div", _hoisted_81, [
                                              _createElementVNode("div", _hoisted_82, [
                                                _createElementVNode("button", {
                                                  class: "image-upload-input-item-delete-btn",
                                                  id: "uploaded-img-delete-btn",
                                                  type: "button",
                                                  onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.clearUploadedImage(true)))
                                                }),
                                                _createElementVNode("input", {
                                                  type: "file",
                                                  id: "editMemberFileInputc",
                                                  onChange: _cache[26] || (_cache[26] = ($event: any) => (_ctx.handleFileUpload($event, true))),
                                                  accept: "image/jpeg,image/jpg,image/png"
                                                }, null, 32)
                                              ]),
                                              _createElementVNode("div", _hoisted_83, [
                                                _createElementVNode("img", {
                                                  src: _ctx.editimageSrc || require('@/assets/images/admin-img/image-icon.svg'),
                                                  alt: ""
                                                }, null, 8, _hoisted_84)
                                              ])
                                            ])
                                          ]),
                                          (!_ctx.selectedEditFile && !_ctx.editimageSrc)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_85, _toDisplayString(_ctx.errEditMsg), 1))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_86, [
                                          _createElementVNode("button", {
                                            class: "admin-btn-outline-primary",
                                            id: "submitBtn",
                                            onClick: ($event: any) => (_ctx.submitEditForm(team.id))
                                          }, _toDisplayString(_ctx.constants.SUBMIT_BUTTON), 9, _hoisted_87),
                                          _createElementVNode("button", {
                                            class: "admin-btn-outline-secondary addNewCancel",
                                            id: "cancelBtn",
                                            onClick: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_ctx.cancelEdit && _ctx.cancelEdit(...args)))
                                          }, _toDisplayString(_ctx.constants.CANCEL_BUTTON), 1)
                                        ])
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ], 2))
                          }), 128))
                        ], 512)
                      ])
                    ])
                  ], 512),
                  _createElementVNode("div", _hoisted_88, [
                    _createElementVNode("div", _hoisted_89, [
                      _createElementVNode("div", _hoisted_90, [
                        _withDirectives(_createElementVNode("select", {
                          id: "paginationSelectBox",
                          "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.limit) = $event)),
                          onChange: _cache[29] || (_cache[29] = 
//@ts-ignore
(...args) => (_ctx.handleLimitChange && _ctx.handleLimitChange(...args)))
                        }, [...(_cache[36] || (_cache[36] = [
                          _createElementVNode("option", { value: "10" }, "10", -1),
                          _createElementVNode("option", { value: "20" }, "20", -1),
                          _createElementVNode("option", { value: "50" }, "50", -1),
                          _createElementVNode("option", { value: "100" }, "100", -1)
                        ]))], 544), [
                          [_vModelSelect, _ctx.limit]
                        ]),
                        _createElementVNode("span", null, _toDisplayString(_ctx.constants.ENTRIES_PER_PAGE_LABEL), 1)
                      ]),
                      (_ctx.totalPages > 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
                            _createElementVNode("ul", null, [
                              (_ctx.currentPage !== 1)
                                ? (_openBlock(), _createElementBlock("li", {
                                    key: 0,
                                    onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.changePage(_ctx.currentPage - 1)))
                                  }, [...(_cache[37] || (_cache[37] = [
                                    _createElementVNode("a", {
                                      href: "#",
                                      class: "pagination-previous"
                                    }, null, -1)
                                  ]))]))
                                : _createCommentVNode("", true),
                              (_ctx.totalPages != 1)
                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.visiblePages, (page) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                      key: page,
                                      onClick: ($event: any) => (_ctx.changePage(page))
                                    }, [
                                      _createElementVNode("a", {
                                        href: "#",
                                        class: _normalizeClass({ active: _ctx.currentPage === page })
                                      }, _toDisplayString(page), 3)
                                    ], 8, _hoisted_92))
                                  }), 128))
                                : _createCommentVNode("", true),
                              (_ctx.currentPage !== _ctx.totalPages)
                                ? (_openBlock(), _createElementBlock("li", {
                                    key: 2,
                                    onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.changePage(_ctx.currentPage + 1)))
                                  }, [...(_cache[38] || (_cache[38] = [
                                    _createElementVNode("a", {
                                      href: "#",
                                      class: "pagination-next"
                                    }, null, -1)
                                  ]))]))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ], 2))
              : (_openBlock(), _createElementBlock("div", _hoisted_93, [...(_cache[39] || (_cache[39] = [
                  _createElementVNode("p", null, "No data to display", -1)
                ]))]))
          ])
        ])
      ])
    ]),
    _createElementVNode("footer", _hoisted_94, [
      _createElementVNode("div", _hoisted_95, _toDisplayString(_ctx.constants.COPYRIGHT_TEXT), 1)
    ]),
    _createElementVNode("div", _hoisted_96, [
      _createElementVNode("div", _hoisted_97, [
        _createElementVNode("div", _hoisted_98, [
          _cache[40] || (_cache[40] = _createElementVNode("div", { class: "confirmation-popup-icon" }, [
            _createElementVNode("i", null, [
              _createElementVNode("img", {
                src: _imports_1,
                alt: ""
              })
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_99, [
            _createElementVNode("p", null, _toDisplayString(_ctx.constants.ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_TEXT), 1)
          ]),
          _createElementVNode("div", _hoisted_100, [
            _createElementVNode("button", _hoisted_101, _toDisplayString(_ctx.constants.NO_BUTTON), 1),
            _createElementVNode("button", {
              id: "popYesBtn",
              class: "admin-btn-outline-primary",
              "data-bs-dismiss": "modal",
              onClick: _cache[32] || (_cache[32] = 
//@ts-ignore
(...args) => (_ctx.confirmDelete && _ctx.confirmDelete(...args)))
            }, _toDisplayString(_ctx.constants.YES_BUTTON), 1)
          ])
        ])
      ])
    ])
  ]))
}